var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-date-picker',{attrs:{"show-current":"","locale":_vm.local,"first-day-of-week":"1","full-width":"","show-week":"","no-title":""},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})
}
var staticRenderFns = []

export { render, staticRenderFns }